export const debounce = (fn: Function, delay = 500) => {
  let timer: ReturnType<typeof setTimeout>;;

  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};
